import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

export default class ShelterPetsService {
  static async getAll(page, limit, { search = '', visible = null, sortOrder = 'asc' } = {}) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const params = new URLSearchParams({ page, limit, sortOrder });
      if (search) params.append('search', search);
      if (visible !== null) params.append('visible', visible);
      const response = await axios.get(`${adminUrl}/shelter-pets?${params.toString()}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data };
      }
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }

  static async getById(shelterPetId) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.get(`${adminUrl}/shelter-pets/${shelterPetId}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }

  static async create(payload) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.post(`${adminUrl}/shelter-pets`, payload, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error', message: response.data.message };
    } catch (error) {
      return {
        status: 'error',
        message: error?.response?.data?.message || 'Error inesperado'
      };
    }
  }

  static async update(shelterPetId, payload) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.put(`${adminUrl}/shelter-pets/${shelterPetId}`, payload, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error', message: response.data.message };
    } catch (error) {
      return {
        status: 'error',
        message: error?.response?.data?.message || 'Error inesperado'
      };
    }
  }

  static async deactivate(shelterPetId) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.patch(`${adminUrl}/shelter-pets/${shelterPetId}`, {}, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok' };
      }
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }
}
